import { all, fork } from 'redux-saga/effects';

import preference from './preference/sagas';

export default function* root() {
    yield all([fork(preference)]);
}
